// ── Guardian Vigil types and messages ──
//
// Phase D of the Ritual Unburdening initiative (AGE-1146).
//
// Guardians do not fight — they resist rest. A Vigil is a multi-day,
// server-wide attendance event where players take shifts sitting with
// a Guardian. Each Vigil progresses through collective ritual phases
// (lighting fires, playing music, building shelter). Completion
// triggers a realm-level restoration event.
//
// Canonical design: docs/design/ritual-unburdening.md §2
// GDD reference: §11 (Softened combat → Vigil conversion)
// ── Guardian → Realm mapping ──
/** Which realm each Guardian belongs to, for restoration wiring. */
export const GUARDIAN_REALM_MAP = {
    hollow_warden: 'verdana_fields',
    duneshade: 'sablewind_reaches',
    frostbound_matriarch: 'frostmere_expanse',
    emberborn_juggernaut: 'ember_mire',
};
// ── Vigil phases ──
/** Sequential phases of a Guardian Vigil. Each requires a different
 *  collective ritual from the attending players. */
export var VigilPhase;
(function (VigilPhase) {
    /** Phase 1: Players light fires around the Guardian. */
    VigilPhase["LightingFires"] = "lighting_fires";
    /** Phase 2: Players play music near the Guardian. */
    VigilPhase["PlayingMusic"] = "playing_music";
    /** Phase 3: Players build shelter over the Guardian. */
    VigilPhase["BuildingShelter"] = "building_shelter";
    /** Final: Guardian has been fully unburdened and rests. */
    VigilPhase["Resting"] = "resting";
})(VigilPhase || (VigilPhase = {}));
/** Ordered progression of Vigil phases (excluding terminal Resting). */
export const VIGIL_PHASE_ORDER = [
    VigilPhase.LightingFires,
    VigilPhase.PlayingMusic,
    VigilPhase.BuildingShelter,
];
/** Progress required to complete each phase (0–100 per phase). */
export const VIGIL_PHASE_THRESHOLD = 100;
// ── Vigil tuning constants ──
/** Presence contribution per second per attending player. */
export const VIGIL_PRESENCE_FILL_PER_SECOND = 0.5;
/** Bonus multiplier when 3+ players are present simultaneously. */
export const VIGIL_CO_PRESENCE_THRESHOLD = 3;
export const VIGIL_CO_PRESENCE_MULTIPLIER = 1.5;
/** Maximum real-time duration of a single Vigil before it auto-expires
 *  (72 real hours = 3 days). Players can resume next lunar cycle. */
export const VIGIL_MAX_DURATION_MS = 72 * 60 * 60 * 1000;
/** Minimum time between Vigil scheduling attempts per Guardian (one
 *  lunar cycle). Tied to DimmingService cadence. */
export const VIGIL_COOLDOWN_LUNAR_CYCLES = 1;
// ── Message constants ──
// Client → Server
export const MSG_VIGIL_JOIN = 'vigil_join';
export const MSG_VIGIL_LEAVE = 'vigil_leave';
export const MSG_VIGIL_RITUAL_ACTION = 'vigil_ritual_action';
// Server → Client
export const MSG_VIGIL_STATE = 'vigil_state';
export const MSG_VIGIL_PHASE_ADVANCE = 'vigil_phase_advance';
export const MSG_VIGIL_COMPLETED = 'vigil_completed';
export const MSG_VIGIL_SCHEDULED = 'vigil_scheduled';
//# sourceMappingURL=vigil.js.map